export default "/signup/_next/static/chunks/fonts/jerry-mini-3a98849f39e8c64780bb7a98e1ec2ca4.eot";